/* Signe R7 5/8: Add to cart + header-"Added"-feedback skal virke paa ALLE sider.
   Global fallback: opsnapper submits paa kort-formularer mod /cart/add, som ingen
   sektion selv har haandteret, koerer add.js og udloeser cd:added-to-cart
   (header-popover) + opdaterer kurv-badges.

   22/8 (Christoffer): Meta-pixlen (fbevents.js) lytter ogsaa paa submit, saetter
   defaultPrevented og kalder BAGEFTER form.submit() programmatisk — dvs. et klassisk
   submit → kunden lander paa /cart. Vores bubble-lytter troede "en sektion har taget den"
   og trak sig. Loesning: (1) capture-fasen koerer FOER pixlen: form.submit goeres til
   no-op paa alle /cart/add-formularer, saa pixlen ikke kan sende dem afsted;
   (2) kort-formularer uden egen sektions-JS haandteres allerede i capture-fasen. */
(function () {
  var FALLBACK = '.cd-hcard__form, .cd-look__form, .cd-rev__form, .cd-tbl__form, .cd-home-starter__form, .cd-rcard form, .pdp-product-card form';
  function noop() {}
  function isCartAdd(form) { return !!(form && form.getAttribute) && /\/cart\/add/.test(form.getAttribute('action') || ''); }
  function updateBadges() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-cart-count], .cart-count-bubble span[aria-hidden="true"], .cd-cart__badge, .cd-mcart__badge').forEach(function (el) { el.textContent = cart.item_count; });
    }).catch(function () {});
  }
  function doAdd(form) {
    var idEl = form.querySelector('input[name="id"]');
    var btn = form.querySelector('button[type="submit"], button:not([type])');
    if (!idEl || !idEl.value || (btn && btn.classList.contains('is-loading'))) return;
    if (btn) btn.classList.add('is-loading');
    /* Video-rettelser 13/8: popover MED DET SAMME (optimistisk) + gront HAK paa knappen */
    var card = form.closest('.cd-hcard, .cd-ccard, .cd-look__item, .cd-rev__strip, .cd-rcard, .pdp-product-card, article') || form.parentElement;
    var img = card ? card.querySelector('img') : null;
    document.dispatchEvent(new CustomEvent('cd:added-to-cart', { detail: { image: (img && img.currentSrc) || '' } }));
    if (btn) {
      var orig = btn.innerHTML;
      btn.classList.add('is-added');
      btn.innerHTML = '<svg viewBox="0 0 14 11" fill="none" aria-hidden="true" style="width:14px;height:11px;display:block;margin:0 auto"><path d="M1 5.5L5 9.5L13 1.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      setTimeout(function () { btn.classList.remove('is-added'); btn.innerHTML = orig; }, 2000);
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(idEl.value, 10), quantity: 1 }] })
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (btn) btn.classList.remove('is-loading');
        if (!res.ok) throw new Error('add failed');
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        updateBadges();
        /* 27/8: paa selve kurvsiden skal varelisten/totalerne med — reload som qty-stepperen */
        if (document.querySelector('.cd-cart-page')) location.reload();
      }).catch(function () {
        if (btn) { btn.classList.remove('is-loading'); btn.classList.add('is-error'); setTimeout(function () { btn.classList.remove('is-error'); }, 1600); }
      });
  }
  /* Capture-fase: foer pixlen og foer alle bubble-lyttere */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!isCartAdd(form)) return;
    try { form.submit = noop; } catch (x) {}
    if (form.matches(FALLBACK) && !form.hasAttribute('data-card-atc')) {
      e.preventDefault();
      e.cdHandled = true;
      doAdd(form);
    }
  }, true);
  /* Bubble-fase: fallback for andre kurv-formularer uden egen JS */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!isCartAdd(form)) return;
    if (e.cdHandled || e.defaultPrevented) return; /* sektionens egen JS har taget den */
    e.preventDefault();
    doAdd(form);
  });
})();
